module.exports = __webpack_public_path__ + "img/headerLogo.cfd3cc13.png";